import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Bitacoras from "../../../views/admin/Bitacoras/Bitacoras";
import Tickets from "../../../views/admin/Tickets/Tickets";
import ListadoColaboradores from "../../../views/admin/ListadoColaboradores/ListadoColaboradores";
import ClientesConRuta from "../../../views/admin/ClientesConRuta/ClientesConRuta";
import PagoAOperador from "../../../views/admin/PagoAOperador/PagoAOperador";


const Admin = () => {
    return (
        <Routes>
           
            <Route exact path="/admin/bitacoras" element={<Suspense fallback={<>skeleton</>}>
                <Bitacoras></Bitacoras>
            </Suspense>} />
            <Route exact path="/admin/tickets" element={<Suspense fallback={<>skeleton</>}>
                <Tickets></Tickets>
            </Suspense>} />
            <Route exact path="/admin/colaboradores" element={<Suspense fallback={<>skeleton</>}>
                <ListadoColaboradores></ListadoColaboradores>
            </Suspense>} />
            <Route exact path="/admin/clientes-rutas" element={<Suspense fallback={<>skeleton</>}>
                <ClientesConRuta></ClientesConRuta>
            </Suspense>} />
            <Route exact path="/admin/pago-operador" element={<Suspense fallback={<>skeleton</>}>
                <PagoAOperador></PagoAOperador>
            </Suspense>} />
        </Routes>
    )
}
export default Admin